// extracted by mini-css-extract-plugin
module.exports = {"card":"IconCardButton_card__1DR8R","icon":"IconCardButton_icon__2BYJB","title":"IconCardButton_title__1fSOF","description":"IconCardButton_description__2thzI"};